<template>
  <!-- v-card здесь сжимал layout: drawer + main должны жить в full-height v-layout под v-app -->
  <v-layout full-height class="price-app-inner-layout">
      <v-navigation-drawer
          permanent
          color="app-chrome"
          expand-on-hover
          rail
          :mobile="false"
      >
        <v-list>
          <v-list-item
              prepend-icon="mdi-account-circle"
              :title="userData?.user?.last_name + ' ' + userData?.user?.name"
              :subtitle="userData?.user?.email"
          ></v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list v-if="hasRole(UserRole.MANAGER)" density="compact" nav>
          <v-list-item prepend-icon="mdi-list-box" title="Прайс" router-link to="/price/"></v-list-item>
          <v-list-item prepend-icon="mdi-exit-run" title="Выйти" router-link to="/" @click="logout"></v-list-item>
        </v-list>
        <v-list v-else density="compact" nav class="sidebar__v-list">
          <v-list-item prepend-icon="mdi-list-box" title="Прайс" router-link to="/price/"></v-list-item>
          <v-list-item prepend-icon="mdi-list-box-outline" title="Номенклатура поставщиков" router-link
                       to="/scat/"></v-list-item>
          <v-list-item @click="dropdown = !dropdown" density="compact" nav prepend-icon="mdi-tune-vertical-variant"
                       title="Настройки"></v-list-item>
          <v-list
              v-if="dropdown"
              density="compact"
              nav
              class="sidebar-nested-list"
          >
            <v-list-item prepend-icon="mdi-upload-circle-outline" title="Импорт" router-link
                         to="/upload/"></v-list-item>
            <v-list-item prepend-icon="mdi-truck-fast-outline" title="Поставщики" router-link
                         to="/suppliers/"></v-list-item>
            <v-list-item prepend-icon="mdi-file-xml-box" title="Фиды" router-link to="/feeds/"></v-list-item>
            <v-list-item prepend-icon="mdi-function-variant" title="Формулы" router-link to="/formulas/"></v-list-item>
            <v-list-item prepend-icon="mdi-cash-multiple" title="Курсы валют" router-link to="/currencies/"></v-list-item>
          </v-list>
          <v-list-item prepend-icon="mdi-exit-run" title="Выйти" router-link to="/" @click="logout"></v-list-item>
        </v-list>
      </v-navigation-drawer>
      <v-main class="price-main-scroll-host flex-grow-1" style="min-height: 0">
        <div class="app-main-scroll">
          <router-view />
        </div>
      </v-main>
  </v-layout>
</template>

<script lang="ts">
export default { name: 'UiSidebar' };
</script>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { UserRole } from '@/constants/roles';
import { useAuth } from '@/composables/useAuth';
const store = useStore();
const { hasRole } = useAuth();
const dropdown = ref(false);

interface SidebarUserPayload {
  user?: { last_name?: string; name?: string; email?: string };
}

const userData = computed((): SidebarUserPayload => {
  const u = store.getters['user/userData'];
  if (u == null || (Array.isArray(u) && u.length === 0)) {
    return {};
  }
  return u as SidebarUserPayload;
});

function logout() {
  localStorage.removeItem('userData');
  store.commit('user/removeUserData');
}
</script>

<style scoped>
.sidebar-nested-list {
  margin: 0 !important;
  padding-inline-start: 0 !important;
}

/**
 * Без v-main scrollable: у .v-main__scroller Vuetify обнуляет --v-layout-* → съезжают fixed-тулбары.
 * Прокрутка только здесь; переменные layout наследуются от v-main как раньше.
 */
.price-main-scroll-host {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto !important;
  min-height: 0;
  max-height: 100%;
  overflow: hidden;
}

.app-main-scroll {
  box-sizing: border-box;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 12px;
}
</style>
